<script>
	import firebase from 'firebase/app';
	import 'firebase/auth';
	import "firebase/firestore";
	import { FirebaseApp } from 'sveltefire';
	import { authState } from 'rxfire/auth';

	import Index from './pages/Index.svelte';
	import Login from './pages/Login.svelte';
	import InviteUser from './pages/InviteUser.svelte';
	import Embed from './pages/Embed.svelte';
	import List from './pages/List.svelte';
	import Location from './pages/Location.svelte';
	import CreateAccount from './pages/CreateAccount.svelte';
	import TermsAndConditions from './pages/TermsAndConditions.svelte';
	import ForgotPassword from './pages/ForgotPassword.svelte';
	import EditFooter from './pages/EditFooter.svelte';
	import Settings from './pages/Settings.svelte';

	import CssRoot from './components/CssRoot.svelte';
	import Header from './components/Header.svelte';
	import Footer from './components/Footer.svelte';
	import Loading from './components/Loading.svelte';

	import { Routes, pushRoute } from './router';
	import { getUrlParam, isNullOrUndefined } from './utils';
	import { page, userOrganizationID, userStore } from './stores';

	const config = {
		apiKey: 'AIzaSyCFbkeHTwbOmFITQAql_qvf5rT4kO-D8ms',
		authDomain: 'campuspano-prod.firebaseapp.com',
		databaseURL: 'https://campuspano-prod.firebaseio.com',
		projectId: 'campuspano-prod',
		storageBucket: 'campuspano-prod.appspot.com',
		messagingSenderId: '451295011948',
		appId: '1:451295011948:web:0ad4c4c6c175d5db7d6449',
		measurementId: 'G-8366ZPXJTH'
	};

	firebase.initializeApp(config);
	const db = firebase.firestore();
	const auth = firebase.auth();

	page.update((n)=> getUrlParam('p'));
	let component;
	page.subscribe((n) => {
		switch (n) {
		case Routes.INDEX:
			component = Index;
			break;
		case Routes.INVITE_USER:
			component = InviteUser;
			break;
		case Routes.EMBED:
			component = Embed;
			break;
		case Routes.LIST:
			component = List;
			break;
		case Routes.LOCATION:
			component = Location;
			break;
		case Routes.CREATE_ACCOUNT:
			component = CreateAccount;
			break;
		case Routes.TERMS_AND_CONDITIONS:
			component = TermsAndConditions;
			break;
		case Routes.FORGOT_PASSWORD:
			component = ForgotPassword;
			break;
		case Routes.EDIT_FOOTER:
			component = EditFooter;
			break;
		case Routes.SETTINGS:
			component = Settings;
			break;
		default:
			component = Index;
		}
	});

	let authResult = false;
	let user;
	const unsubscribe = authState(auth).subscribe((u) => {
		authResult = true;
		user = u;
		if (!isNullOrUndefined(u) && !isNullOrUndefined(u.uid) && !isNullOrUndefined(u.email)) {
			db.collection('users').doc(u.uid).set({
				uid: u.uid,
				email: u.email
			}, { 
				merge: true
			});
		}
		if (!isNullOrUndefined(u)) {
			db.collection('users').doc(user.uid).get().then((userDoc) => {
				if (userDoc.exists) {
					const data = userDoc.data();
					userStore.update((a) => {
						data.emailVerified = u.emailVerified;
						return data;
					});
					userOrganizationID.update((n) => data.organizationID);
				}
			}).catch((e) => {
				console.log('Error: ', e);
			});
		}
	});
</script>

<CssRoot />
<FirebaseApp firebase={firebase} >
	<div class="wrapper">
		<Header loggedIn={(user) ? true : false} />
		<div class="page">
			{#if !authResult}
				<Loading />
			{:else if user}
				<svelte:component this={component} />
			{:else if $page === Routes.CREATE_ACCOUNT}
				<CreateAccount />
			{:else if $page === Routes.FORGOT_PASSWORD}
				<ForgotPassword />
			{:else}
				<Login />
			{/if}
		</div>
	</div>
	<Footer loggedIn={(user) ? true : false} />
</FirebaseApp>

<style>
	.wrapper {
		flex: 1 0 auto;
	}

	.page {
		text-align: center;
		margin: auto;
		max-width: 1000px;
		padding: 20px;
	}
</style>
